export const currentVersion = 0.8;
